/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCategory
 */
export interface ProductCategory {
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductCategory
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductCategory
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    categoryName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategory
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCategory
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductCategory
     */
    statusDate?: Date;
}

export function ProductCategoryFromJSON(json: any): ProductCategory {
    return ProductCategoryFromJSONTyped(json, false);
}

export function ProductCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'categoryName': !exists(json, 'category_name') ? undefined : json['category_name'],
        'isAvailable': !exists(json, 'is_available') ? undefined : json['is_available'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
    };
}

export function ProductCategoryToJSON(value?: ProductCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'category_name': value.categoryName,
        'is_available': value.isAvailable,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
    };
}


